import { render, staticRenderFns } from "./messagerie.vue?vue&type=template&id=2803bcea"
import script from "./messagerie.vue?vue&type=script&lang=js"
export * from "./messagerie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports